'use client'

import React from 'react'
import { PageProjectDetailsFragment } from '@/gql/generated/graphql'
import { AllPurposeLink } from '@components/all-purpose-link'
import { LoadingSpinner } from '@components/loading-spinner'
import { projectShowRoute } from '@utils/routes'
import { BodyText } from 'design-configuration/components'
import { ImageWithCustomLoader } from '@components/image-with-custom-loader'
type ArticleCollectionsDisplayProps = {
  project?: PageProjectDetailsFragment | null
}

export const ArticleCollectionsDisplay = ({ project }: ArticleCollectionsDisplayProps): React.ReactElement => {
  const [imageLoaded, setImageLoaded] = React.useState(false)

  const projectHref = projectShowRoute(project?.slug ?? '')
  const featuredToken = project?.featured_token?.[0]
  return (
    <div className="h-full w-full">
      <div className="bg-surface-low relative h-[246px]">
        {!imageLoaded ? (
          <div className="flex h-full w-full items-center justify-center">
            <LoadingSpinner className="h-md w-md" />
          </div>
        ) : null}
        <AllPurposeLink href={projectHref}>
          <ImageWithCustomLoader
            onLoad={() => setImageLoaded(true)}
            src={featuredToken?.media_url ?? ''}
            className="p-md drop-shadow-[3px_3px_6px_rgba(0,0,0,0.20)] transition-all duration-100 hover:scale-[101%] hover:drop-shadow-[3px_5px_7px_rgba(0,0,0,0.20)]"
            fill
            style={{
              objectFit: 'contain',
              objectPosition: 'center'
            }}
            alt={`Featured token for: ${project?.name}`}
            sizes="35vw"
          />
        </AllPurposeLink>
      </div>
      <AllPurposeLink href={projectHref}>
        <BodyText className="mt-md text-center font-medium">{project?.name}</BodyText>
      </AllPurposeLink>
      <BodyText className="text-center">{project?.artist_name}</BodyText>
    </div>
  )
}
